import { FacebookBroadcast } from 'types';
import api from 'services/api';

export type CreateBroadcastData = {
  userId: number;
  title: string;
};

const requests = {
  createBroadcast: ({ userId, title }: CreateBroadcastData) =>
    api.instances.facebook.post<FacebookBroadcast>(`/${userId}/live_videos`, undefined, {
      params: {
        status: 'LIVE_NOW',
        title
      }
    })
};

export default requests;
